import { approvalChartDefault } from "./defaults.ts";
//http://news.gallup.com/poll/203198/presidential-approval-ratings-donald-trump.aspx

export const trumpApp = [
  { start: new Date(`2021 Jan 4`), app: 34, dis: 62, neu: 4 },
  { start: new Date(`2020 Dec 1`), app: 39, dis: 57, neu: 5 },
  { start: new Date(`2020 Nov 5`), app: 43, dis: 55, neu: 2 },
  { start: new Date(`2020 Oct 16`), app: 46, dis: 52, neu: 1 },
  { start: new Date(`2020 Sep 30`), app: 43, dis: 55, neu: 2 },
  { start: new Date(`2020 Sep 14`), app: 46, dis: 52, neu: 2 },
  { start: new Date(`2020 Aug 31`), app: 42, dis: 56, neu: 2 },
  { start: new Date(`2020 Jul 30`), app: 42, dis: 55, neu: 4 },
  { start: new Date(`2020 Jul 1`), app: 41, dis: 56, neu: 3 },
  { start: new Date(`2020 Jun 8`), app: 38, dis: 57, neu: 4 },
  { start: new Date(`2020 May 28`), app: 39, dis: 57, neu: 4 },
  { start: new Date(`2020 May 1`), app: 49, dis: 48, neu: 3 },
  { start: new Date(`2020 Apr 14`), app: 49, dis: 47, neu: 4 },
  { start: new Date(`2020 Apr 1`), app: 43, dis: 54, neu: 4 },
  { start: new Date(`2020 Mar 13`), app: 49, dis: 45, neu: 6 },
  { start: new Date(`2020 Mar 2`), app: 44, dis: 52, neu: 4 },
  { start: new Date(`2020 Feb 17`), app: 47, dis: 51, neu: 2 },
  { start: new Date(`2020 Feb 3`), app: 49, dis: 48, neu: 3 },
  { start: new Date(`2020 Jan 16`), app: 49, dis: 50, neu: 1 },
  { start: new Date(`2020 Jan 2`), app: 44, dis: 53, neu: 3 },
  { start: new Date(`2019 Dec 2`), app: 45, dis: 51, neu: 3 },
  { start: new Date(`2019 Nov 1`), app: 43, dis: 54, neu: 3 },
  { start: new Date(`2019 Oct 14`), app: 41, dis: 57, neu: 2 },
  { start: new Date(`2019 Oct 1`), app: 39, dis: 57, neu: 5 },
  { start: new Date(`2019 Sep 16`), app: 40, dis: 56, neu: 3 },
  { start: new Date(`2019 Sep 3`), app: 43, dis: 54, neu: 4 },
  { start: new Date(`2019 Aug 15`), app: 39, dis: 57, neu: 4 },
  { start: new Date(`2019 Aug 1`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2019 Jul 15`), app: 42, dis: 54, neu: 4 },
  { start: new Date(`2019 Jul 1`), app: 44, dis: 51, neu: 5 },
  { start: new Date(`2019 Jun 19`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2019 Jun 3`), app: 43, dis: 55, neu: 3 },
  { start: new Date(`2019 May 15`), app: 40, dis: 55, neu: 4 },
  { start: new Date(`2019 May 1`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2019 Apr 17`), app: 46, dis: 50, neu: 4 },
  { start: new Date(`2019 Apr 1`), app: 45, dis: 51, neu: 4 },
  { start: new Date(`2019 Mar 1`), app: 39, dis: 57, neu: 4 },
  { start: new Date(`2019 Feb 12`), app: 43, dis: 54, neu: 3 },
  { start: new Date(`2019 Feb 1`), app: 44, dis: 52, neu: 4 },
  { start: new Date(`2019 Jan 21`), app: 37, dis: 59, neu: 3 },
  { start: new Date(`2019 Jan 2`), app: 37, dis: 59, neu: 4 },
  { start: new Date(`2018 Dec 17`), app: 39, dis: 55, neu: 5 },
  { start: new Date(`2018 Dec 10`), app: 38, dis: 57, neu: 4 },
  { start: new Date(`2018 Dec 3`), app: 40, dis: 56, neu: 4 },
  { start: new Date(`2018 Nov 26`), app: 40, dis: 56, neu: 4 },
  { start: new Date(`2018 Nov 19`), app: 38, dis: 60, neu: 3 },
  { start: new Date(`2018 Nov 12`), app: 43, dis: 53, neu: 4 },
  { start: new Date(`2018 Nov 5`), app: 38, dis: 56, neu: 5 },
  { start: new Date(`2018 Oct 29`), app: 40, dis: 54, neu: 6 },
  { start: new Date(`2018 Oct 22`), app: 40, dis: 54, neu: 6 },
  { start: new Date(`2018 Oct 15`), app: 44, dis: 50, neu: 6 },
  { start: new Date(`2018 Oct 8`), app: 44, dis: 51, neu: 5 },
  { start: new Date(`2018 Oct 1`), app: 43, dis: 53, neu: 5 },
  { start: new Date(`2018 Sep 24`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2018 Sep 17`), app: 40, dis: 56, neu: 5 },
  { start: new Date(`2018 Sep 10`), app: 38, dis: 56, neu: 6 },
  { start: new Date(`2018 Sep 3`), app: 40, dis: 54, neu: 5 },
  { start: new Date(`2018 Aug 27`), app: 41, dis: 53, neu: 6 },
  { start: new Date(`2018 Aug 20`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2018 Aug 13`), app: 42, dis: 52, neu: 7 },
  { start: new Date(`2018 Aug 6`), app: 39, dis: 56, neu: 5 },
  { start: new Date(`2018 Jul 30`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2018 Jul 23`), app: 40, dis: 55, neu: 6 },
  { start: new Date(`2018 Jul 16`), app: 42, dis: 54, neu: 4 },
  { start: new Date(`2018 Jul 9`), app: 43, dis: 52, neu: 4 },
  { start: new Date(`2018 Jul 2`), app: 41, dis: 56, neu: 4 },
  { start: new Date(`2018 Jun 25`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2018 Jun 18`), app: 41, dis: 55, neu: 3 },
  { start: new Date(`2018 Jun 11`), app: 45, dis: 50, neu: 4 },
  { start: new Date(`2018 Jun 4`), app: 42, dis: 54, neu: 4 },
  { start: new Date(`2018 May 28`), app: 41, dis: 55, neu: 4 },
  { start: new Date(`2018 May 21`), app: 40, dis: 55, neu: 6 },
  { start: new Date(`2018 May 14`), app: 42, dis: 54, neu: 5 },
  { start: new Date(`2018 May 7`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2018 Apr 30`), app: 42, dis: 52, neu: 5 },
  { start: new Date(`2018 Apr 23`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2018 Apr 16`), app: 38, dis: 57, neu: 6 },
  { start: new Date(`2018 Apr 9`), app: 39, dis: 55, neu: 6 },
  { start: new Date(`2018 Apr 2`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2018 Mar 26`), app: 39, dis: 56, neu: 5 },
  { start: new Date(`2018 Mar 19`), app: 39, dis: 55, neu: 5 },
  { start: new Date(`2018 Mar 12`), app: 40, dis: 56, neu: 4 },
  { start: new Date(`2018 Mar 5`), app: 39, dis: 56, neu: 4 },
  { start: new Date(`2018 Feb 26`), app: 39, dis: 55, neu: 6 },
  { start: new Date(`2018 Feb 19`), app: 39, dis: 56, neu: 5 },
  { start: new Date(`2018 Feb 12`), app: 37, dis: 59, neu: 4 },
  { start: new Date(`2018 Feb 5`), app: 40, dis: 57, neu: 3 },
  { start: new Date(`2018 Jan 29`), app: 40, dis: 57, neu: 3 },
  { start: new Date(`2018 Jan 22`), app: 38, dis: 57, neu: 5 },
  { start: new Date(`2018 Jan 15`), app: 36, dis: 59, neu: 5 },
  { start: new Date(`2018 Jan 8`), app: 38, dis: 57, neu: 5 },
  { start: new Date(`2018 Jan 1`), app: 37, dis: 58, neu: 4 },
  { start: new Date(`2017 Dec 25`), app: 39, dis: 55, neu: 6 },
  { start: new Date(`2017 Dec 18`), app: 37, dis: 57, neu: 6 },
  { start: new Date(`2017 Dec 11`), app: 35, dis: 60, neu: 5 },
  { start: new Date(`2017 Dec 4`), app: 36, dis: 59, neu: 5 },
  { start: new Date(`2017 Nov 27`), app: 35, dis: 59, neu: 5 },
  { start: new Date(`2017 Nov 20`), app: 37, dis: 56, neu: 7 },
  { start: new Date(`2017 Nov 13`), app: 38, dis: 57, neu: 6 },
  { start: new Date(`2017 Nov 6`), app: 38, dis: 56, neu: 6 },
  { start: new Date(`2017 Oct 30`), app: 38, dis: 58, neu: 5 },
  { start: new Date(`2017 Oct 23`), app: 35, dis: 60, neu: 5 },
  { start: new Date(`2017 Oct 16`), app: 36, dis: 58, neu: 6 },
  { start: new Date(`2017 Oct 9`), app: 37, dis: 57, neu: 6 },
  { start: new Date(`2017 Oct 2`), app: 38, dis: 56, neu: 6 },
  { start: new Date(`2017 Sep 25`), app: 37, dis: 58, neu: 5 },
  { start: new Date(`2017 Sep 18`), app: 38, dis: 55, neu: 6 },
  { start: new Date(`2017 Sep 11`), app: 38, dis: 57, neu: 6 },
  { start: new Date(`2017 Sep 4`), app: 37, dis: 57, neu: 6 },
  { start: new Date(`2017 Aug 28`), app: 36, dis: 59, neu: 6 },
  { start: new Date(`2017 Aug 21`), app: 35, dis: 60, neu: 5 },
  { start: new Date(`2017 Aug 14`), app: 37, dis: 58, neu: 6 },
  { start: new Date(`2017 Aug 7`), app: 36, dis: 58, neu: 6 },
  { start: new Date(`2017 Jul 31`), app: 37, dis: 58, neu: 5 },
  { start: new Date(`2017 Jul 24`), app: 38, dis: 57, neu: 5 },
  { start: new Date(`2017 Jul 17`), app: 37, dis: 58, neu: 5 },
  { start: new Date(`2017 Jul 10`), app: 39, dis: 56, neu: 6 },
  { start: new Date(`2017 Jul 3`), app: 38, dis: 57, neu: 5 },
  { start: new Date(`2017 Jun 26`), app: 39, dis: 56, neu: 5 },
  { start: new Date(`2017 Jun 19`), app: 39, dis: 56, neu: 5 },
  { start: new Date(`2017 Jun 12`), app: 38, dis: 57, neu: 6 },
  { start: new Date(`2017 Jun 5`), app: 37, dis: 58, neu: 5 },
  { start: new Date(`2017 May 29`), app: 38, dis: 56, neu: 6 },
  { start: new Date(`2017 May 22`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2017 May 15`), app: 38, dis: 56, neu: 6 },
  { start: new Date(`2017 May 8`), app: 38, dis: 56, neu: 6 },
  { start: new Date(`2017 May 1`), app: 42, dis: 53, neu: 6 },
  { start: new Date(`2017 Apr 24`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2017 Apr 17`), app: 41, dis: 52, neu: 7 },
  { start: new Date(`2017 Apr 10`), app: 40, dis: 54, neu: 6 },
  { start: new Date(`2017 Apr 3`), app: 40, dis: 53, neu: 7 },
  { start: new Date(`2017 Mar 27`), app: 38, dis: 57, neu: 5 },
  { start: new Date(`2017 Mar 20`), app: 39, dis: 56, neu: 6 },
  { start: new Date(`2017 Mar 13`), app: 40, dis: 55, neu: 5 },
  { start: new Date(`2017 Mar 6`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2017 Feb 27`), app: 43, dis: 51, neu: 6 },
  { start: new Date(`2017 Feb 20`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2017 Feb 13`), app: 40, dis: 54, neu: 5 },
  { start: new Date(`2017 Feb 6`), app: 41, dis: 53, neu: 6 },
  { start: new Date(`2017 Jan 30`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2017 Jan 20`), app: 45, dis: 47, neu: 8 },
];

export const trumpAppData = {
  president: `Donald J. Trump`,
  party: `republican`,
  chart: Object.assign({}, approvalChartDefault, {
    title: { text: `Presidential Approval Poll for Donald Trump` },
  }),
};
